import { restPost } from "./RestClient";

export async function FetchCampaignSites(data) {
    const res = await restPost(`Ads_Clients/FetchCampaignSites`, data);
    return res.data;
}
export async function SaveCampaignSites(data) {
    const res = await restPost(`Ads_Clients/SaveCampaignSites`, data);
    return res.data;
}
export async function DeleteCampaignSites(data) {
    const res = await restPost(`Ads_Clients/DeleteCampaignSites`, data);
    return res.data;
}


export async function FetchCampaignSitesInViewport(data) {
    const res = await restPost(`Ads_Clients/FetchCampaignSitesInViewport`, data);
    return res.data;
}